import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Polygon } from '@tcc/treadstone';
import { Spinner } from '@tcc/crate';
import styles from './ImportedShapefileMap.css';
import { reqImportedShapefileData } from '../../../actions/mosaicActions';
import {
  importedShapefilePropertiesSelector,
  activeImportedShapefileSelector,
} from '../../../selectors/mosaicSelectors';

export class ImportedShapefileMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePropertyIndex: 0,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      activeShapefile,
      userId,
      properties,
      reqImportedShapefileData: reqImportedShapefileDataProp,
    } = this.props;
    if (!properties) {
      reqImportedShapefileDataProp(
        activeShapefile.fieldId,
        userId,
        activeShapefile.eventDate,
        activeShapefile.uuid,
        activeShapefile.shapefileUri
      );
    }
  }

  render() {
    const { properties } = this.props;
    const { activePropertyIndex } = this.state;
    if (!properties) {
      return <Spinner className={styles.loading} color="white" size="20" />;
    }
    const activeProperty = properties[activePropertyIndex];

    return (
      <div>
        {activeProperty.geometries.map((geometry) => (
          <Polygon
            color="white"
            fillColor={geometry.color}
            fillOpacity={0.5}
            key={`imported-shapefile-property-${activeProperty.name}-${geometry.value}`}
            positions={geometry.coordinates}
            weight={4}
          />
        ))}
      </div>
    );
  }
}

ImportedShapefileMap.propTypes = {
  activeShapefile: PropTypes.object.isRequired,
  properties: PropTypes.array,
  reqImportedShapefileData: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    activePropertyIndex: state.activePropertyIndex,
    activeShapefile: activeImportedShapefileSelector(state),
    properties: importedShapefilePropertiesSelector(state),
    userId: state.user.id,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      reqImportedShapefileData,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportedShapefileMap);
